import { useQuery } from '@tanstack/react-query';
import { Assignee } from 'infrastructure/enums';

import {
  DASHBOARD_ACTIVITY_PER_PAGE,
  getActivityCountFn,
  getRpmActivityCountKey,
  getRpmActivityKey,
} from './use-get-dashboard-activity';

import type {
  TDashboardActivityFilter,
  TDashboardActivityFilterWithDoctorString,
} from './use-get-dashboard-activity';

export const useReadingsCount = (filter: TDashboardActivityFilter) => {
  const filterWithItems: TDashboardActivityFilterWithDoctorString = {
    ...filter,
    assignee: filter.assignee === Assignee.All ? undefined : filter.assignee,
    doctorGuid: filter.doctorGuid?.join(','),
    items: DASHBOARD_ACTIVITY_PER_PAGE,
    applySpecialFilter: false,
  };

  const queryKey = getRpmActivityKey(filterWithItems);

  const {
    data: activityCount,
    isLoading: countLoading,
    refetch: refetchCount,
  } = useQuery({
    queryKey: getRpmActivityCountKey(filterWithItems),
    queryFn: async () => getActivityCountFn(filterWithItems),
    enabled: Boolean(filter.startTime || filter.endTime),
  });

  return {
    queryKey,
    activityCount,
    countLoading,
    refetchCount,
  };
};
